import { StringMatchType } from '@decisions/server/DecisionsFramework/Design/Report/Service/FilterFactory';
import { IActionLinkItem } from 'components/ActionLinks/ActionLinkModels';

export const DEFAULT_STRING_MATCH_TYPE_LABELS = new Map([
  [StringMatchType.Equals, 'Equals'],
  [StringMatchType.DoesNotEqual, 'Does Not Equal'],
  [StringMatchType.Contains, 'Contains'],
  [StringMatchType.IsNotEmpty, 'Is Not Empty'],
  [StringMatchType.IsEmpty, 'Is Empty'],
  [StringMatchType.StartsWith, 'Starts With'],
  [StringMatchType.EndsWith, 'Ends With'],
  [StringMatchType.DoesNotContain, 'Does Not Contain'],
  [StringMatchType.DoesNotEndWith, 'Does Not End With'],
  [StringMatchType.DoesNotStartWith, 'Does Not Start With'],
]);

export function getLabelForStringMatchType(type: StringMatchType) {
  return DEFAULT_STRING_MATCH_TYPE_LABELS.get(type) as string;
}

// TODO need translation of these?
export function getStringMatchOptions(callback?: () => void): IActionLinkItem[] {
  return Array.from(DEFAULT_STRING_MATCH_TYPE_LABELS.keys()).map(value => ({
    value,
    label: getLabelForStringMatchType(value),
    callback,
  }));
}
